import React, { useEffect } from 'react'
import { useOidc } from '@axa-fr/react-oidc'
import { defineMessages, useIntl } from 'react-intl'
import OpenIdStatusPage from './OpenIdStatusPage'
import {
  SIGN_IN_RETURN_PATH,
  interactiveSignInExtras,
  silentSignInNeedsThePerson
} from '../../helpers/invitedSite'

const localMessages = defineMessages({
  headline: {
    id: 'screens.openIdStatusPage.headline'
  },
  pleaseWait: {
    id: 'screens.openIdStatusPage.pleaseWait'
  },
  errorHeadline: {
    id: 'screens.openIdStatusPage.errorHeadline'
  },
  errorBody: {
    id: 'screens.openIdStatusPage.errorBody'
  }
})

// Shown when a sign-in comes back with an error. The landing page always tries a
// silent sign-in first; when Keycloak has no session for the person it answers
// login_required, which is not a failure but the cue to ask them - so that goes
// straight to the sign-in screen, with the pending invitation, instead of an
// error page. Anything else is a real failure and offers a retry.
const AuthenticatingError = () => {
  const { login } = useOidc()
  const intl = useIntl()
  const needsThePerson = silentSignInNeedsThePerson(window.location.search)

  useEffect(() => {
    if (!needsThePerson) return
    const returnPath = sessionStorage.getItem(SIGN_IN_RETURN_PATH) || '/'
    sessionStorage.removeItem(SIGN_IN_RETURN_PATH)
    login(returnPath, interactiveSignInExtras())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return needsThePerson ? (
    <OpenIdStatusPage
      headline={intl.formatMessage(localMessages.headline)}
      body={intl.formatMessage(localMessages.pleaseWait)}
    />
  ) : (
    <OpenIdStatusPage
      headline={intl.formatMessage(localMessages.errorHeadline)}
      body={intl.formatMessage(localMessages.errorBody)}
      showRetryButton
    />
  )
}

export default AuthenticatingError
